import React from "react";
import MovieList from "./MovieList";

const MoviesPage = () => {
  return (
    <div>
      <MovieList />
    </div>
  );
};

export default MoviesPage;
